import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "CriusesOutline__IconWrapper",
  componentId: "sc-1c3k4i7-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    d: "M12.02 1.5a.5.5 0 0 1 .492.41l.008.09v1.44h2.25a.5.5 0 0 1 .35.143l.062.074L16.786 6 19.21 6a.5.5 0 0 1 .497.446l.002.084-.254 4.167 2.736.803a.5.5 0 0 1 .35.58l-.025.082-3.437 8.809c.137.097.265.129.441.129.3 0 .457-.092.762-.443l.11-.13c.552-.665.916-.927 1.628-.927a.5.5 0 1 1 0 1c-.294 0-.449.09-.751.439l-.11.13c-.554.667-.921.931-1.639.931-.662 0-1.026-.224-1.517-.783l-.129-.15c-.38-.454-.537-.567-.864-.567-.295 0-.452.091-.758.443l-.108.127c-.556.668-.92.93-1.634.93-.659 0-1.02-.223-1.509-.783l-.125-.147c-.381-.457-.538-.57-.866-.57-.295 0-.452.091-.758.443l-.108.127c-.556.668-.92.93-1.634.93-.658 0-1.021-.224-1.512-.783l-.125-.146c-.383-.458-.54-.571-.863-.571-.29 0-.444.09-.746.439l-.11.13c-.554.667-.92.931-1.634.931-.659 0-1.02-.223-1.509-.783l-.125-.147c-.381-.457-.538-.57-.866-.57a.5.5 0 1 1 0-1c.659 0 1.02.223 1.509.783l.125.147c.381.457.538.57.866.57a.68.68 0 0 0 .455-.143l-3.44-8.795a.5.5 0 0 1 .244-.63l.08-.032 2.727-.8-.245-4.17a.5.5 0 0 1 .415-.523L4.84 6l2.423-.001 1.605-2.342a.5.5 0 0 1 .315-.207l.097-.01h2.24V2a.5.5 0 0 1 .5-.5"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.light")(themeProps),
    d: "m12.528 9.708 8.858 2.598-3.068 7.859c-.397-.4-.743-.565-1.308-.565-.659 0-1.02.223-1.509.783l-.233.274c-.306.352-.463.443-.758.443s-.452-.091-.758-.443l-.233-.274c-.347-.396-.629-.624-.998-.723zm-.999-.003-.01 9.95c-.379.096-.665.324-1.018.728l-.233.274c-.306.352-.463.443-.758.443-.296 0-.455-.092-.762-.444l-.237-.277c-.447-.51-.787-.74-1.344-.774l-.115-.005-.065-.01c-.334-.034-.67.074-1.014.31l-.148.109-.111.09-3.05-7.794zm2.977-5.265 1.068 1.559h-7.1L9.544 4.44z"
  }), React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "m18.678 7-.208 3.408-6.3-1.848-.14-.02-.15.02-6.309 1.851L5.37 7z"
  })));
}
const CriusesOutline = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(CriusesOutline);
export default Memo;